// AutoGenerated
export enum EnmSoruTipi {
    "Metin" = 1,
    "Tek Seçmeli" = 2,
    "Çok Seçmeli" = 3,
    "Sıralama" = 4,
    "Uzun Metin" = 5,
}